export const SECTION_OPTIONS = ["MEN", "WOMEN", "KIDS"];

export const resolveRowSection = (row, sectionFallback = "") =>
	row?.section_label ?? row?.section ?? sectionFallback ?? "";

export const getSectionFilterOptions = (targetsMeta) => {
	if (targetsMeta?.sections?.length) {
		return targetsMeta.sections.map((item) => {
			if (typeof item === "string") return item;
			return item?.label ?? item?.key ?? item;
		});
	}
	return SECTION_OPTIONS;
};